import { Component, HostListener, Input, OnDestroy } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Contract } from "@edp-components/edp-contract";
import { EdpUser } from "@edp-models/user.model";
import { OpenSidebarAction, SelectOverlayAction } from "@edp-store/actions/layout.actions";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getUserNotificationsTotalNotViewed } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { Observable, of, Subject } from "rxjs";
import { filter, switchMap, takeUntil } from "rxjs/operators";
import { UserNotificationsGetAll } from "@edp-store/actions/user.actions";
import { getMainMenu, getShowHeaderAlert } from "@edp-store/selectors/layout.selectors";
import { AppBannerService } from "@edp-services/app-banner.service";
import { EnvService } from "@edp-services/env.service";
import { OperationHistoryEsEnum } from "@edp-enums/ES/operation-history-es-enum";
import { OperationHistoryService } from "@edp-services/operation-history.service";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { getContractEs } from "@edp-store/selectors/ES/contract-es.selectors";
import { ContractEs } from "@edp-models/ES/es-contract.model";

@Component({
    selector: "edp-header",
    templateUrl: "./edp-header.component.html",
    styleUrls: ["./edp-header.component.scss"],
})
export class EdpHeaderComponent implements OnDestroy {
    @Input() contracts: Contract[];
    @Input() user: EdpUser;

    public appUrl: string = null;
    public headerTitle: string = null;
    public scroll: boolean;
    public link: string[];
    public totalNotificationsNotViewed = 0;
    public showAlert: boolean;
    public hasMobileBreadcrumb = false;
    public showAppBanner = false;
    public contract: Contract;
    public contractES: ContractEs;

    public withoutSubMenu$: Observable<boolean> = this.store.pipe(
        select(getMainMenu),
        filter(menu => menu.length > 0),
        switchMap(menu => {
            const menuSelected = menu.find(item => item.isActive);
            return of(menuSelected && menuSelected.submenu.length === 0);
        })
    );

    private unsubscribe = new Subject();

    @HostListener("window:scroll", [])
    onScroll(): void {
        if (window.scrollY === 0) {
            this.scroll = false;
        } else {
            this.scroll = true;
        }
    }

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private store: Store<IAppState>,
        private storeES: Store<IAppEsState>,
        private readonly appBannerService: AppBannerService,
        private envService: EnvService,
        private readonly operationHistoryService: OperationHistoryService
    ) {
        this.appUrl = this.envService.appUrl();
        this.showAppBanner = this.appBannerService.show();

        this.subscribeNavigationEnd();
        this.store.pipe(takeUntil(this.unsubscribe), select(getUserNotificationsTotalNotViewed)).subscribe(val => {
            this.totalNotificationsNotViewed = val;
        });

        this.storeES.pipe(select(getContractEs), takeUntil(this.unsubscribe)).subscribe((contract: ContractEs) => {
            if (contract) {
                this.contractES = contract;
                this.link = [`/energia/${contract.id}/inicio`];
            }
        });

        this.store.pipe(select(getContract), takeUntil(this.unsubscribe)).subscribe((contract: Contract) => {
            if (contract) {
                this.contract = contract;
                this.link = [`/energia/${contract.ContractId}/inicio`];
            }
        });

        this.store.pipe(takeUntil(this.unsubscribe), select(getShowHeaderAlert)).subscribe((alertStatus: boolean) => {
            this.showAlert = alertStatus;
        });
    }

    subscribeNavigationEnd() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.headerTitle = this.activatedRoute.firstChild.snapshot.data.title;
            }
        });
    }

    public openSidebar() {
        this.store.dispatch(new OpenSidebarAction());
    }

    public selectOverlay(type: string): void {
        if (type === "notifications") {
            this.store.dispatch(new UserNotificationsGetAll());
        }
        if (type === "user") {
            this.sendOperationHistoryService(OperationHistoryEsEnum[type.toUpperCase()]);
        }
        this.store.dispatch(new SelectOverlayAction(type));
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    public showMobileBreadcrumb(event) {
        this.hasMobileBreadcrumb = event;
    }

    get isDashboard() {
        return location.href.includes("energia") && location.href.includes("/inicio");
    }


    get isBenefits() {
        return location.href.match(/\/beneficios*$/gm) || location.href.includes("/pack");
    }

    private sendOperationHistoryService(key: string, value: string | null = null) {
        const contractId = !!this.contract?.ContractId ? this.contract?.ContractId : !!this.contractES ? this.contractES.id : null;
        this.operationHistoryService.registerWithContract(contractId, key, value, null, null, false);
    }
}
